<template>
  <w-popup-show class="comment-detail-container" :state="commentDetailShow" @handleClose="handleClose">
    <div slot="content" class="comment-detail-content">
      <div class="detail-header flex-between">
        <span class="iconfont iconx" @click="handleClose"/>
        <span class="title">评论详情</span>
        <span/>
      </div>
      <div class="comment-detail" v-if="commentData.reply_comments">
        <cube-scroll :data="commentData.reply_comments.comments" :options="options" @pulling-up="onPullingUp">
          <div class="comment-item flex-column">
            <div class="comment-user-info flex-between">
              <div class="info" v-if="commentData.user">
                <img class="avatar" :src="commentData.user.avatar_url" alt="">
                <div  class="user-info-box">
                  <div class="flex-start">
                    <span class="root-comment-user">{{ commentData.user.username || '超级简历用户' }}{{isAuthor(author,commentData.user)?'(作者)':''}}</span>
                    <official :is_rb="commentData.user.is_rb" :adminId="commentData.admin_id" style="margin-left: 5px"/>
                  </div>
                  <div class="identity" v-if="commentData.user.community_identity">
                    {{commentData.user.community_identity}}
                  </div>
                </div>
              </div>
              <div class="approve flex-start" @click="updateLikeStatus(commentData)" v-show="!commentData.is_delete">
                <span
                    style="position: static;margin-right: 3px">{{ commentData.like_count | countFilter('like') }}</span>
                <span
                    :class="['iconfont', commentData.my_status.has_liked ? 'icondianzan1' : 'iconweidianzan1']"
                    style="position: static;margin-right: -22px"></span>
              </div>
            </div>
            <div class="comment-item-content">
              <p class="comment-content-text" :style="{color:commentData.is_delete?'#9c9c9c':'#404040'}"
                 @touchstart.prevent="onTouchStart(commentData)" @touchmove.prevent="onTouchMove"
                 @touchend.prevent="onTouchEnd(commentData)">
                {{ commentData.is_delete ? '该评论已删除' : commentData.content }}
              </p>
              <div class="comment-content-bottom flex-between">
                <span class="comment-time">{{ commentData.publish_at | articleTimeFormatFilter }}</span>
              </div>
            </div>
          </div>
          <template v-if="commentData.reply_comments">
            <div class="comment-root-detail" v-if="commentData.reply_comments.reply_comment_count">
              <template v-for="(item, index) in commentData.reply_comments.comments">
                <div class="comment-item flex-column" :key="index" style="background-color: #f9f9f9">
                  <div class="comment-user-info flex-between comment-over">
                    <div class="comment-between">
                      <div class="flex-start">
                        <img class="avatar" :src="item.user.avatar_url" alt="" width="30" height="30">
                        <div>
                          <div class="flex">
                            <div class="info flex-start" v-if="item.user">
                              <span class="comment-over">{{ item.user.username || '超级简历用户' }}{{isAuthor(author,item.user)?'(作者)':''}}</span>
                              <official :is_rb="item.user.is_rb" :adminId="item.admin_id" style="margin-left: 5px"/>
                            </div>
                            <span class="iconfont iconRectangle"></span>
                            <!--                      <div class="reply-to-user" >-->
                            <span class="user-name" style="color:#4183FF"
                                  v-if="item.reply_to_user">{{ item.reply_to_user.username || '超级简历用户' }}{{isAuthor(author,item.reply_to_user)?'(作者)':''}}</span>
                          </div>
                          <div class="identity" v-if="item.user.community_identity">
                            {{item.user.community_identity}}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="approve" @click="updateLikeStatus(item)" v-show="!item.is_delete">
                      <span>{{ item.like_count ?item.like_count :''}}</span>
                      <transition name="like">
                        <span v-if="item.my_status.has_liked" class="iconfont icondianzan1"></span>
                      </transition>
                      <transition name="not">
                        <span v-if="!item.my_status.has_liked" class="iconfont iconweidianzan1"></span>
                      </transition>
                    </div>
                  </div>
                  <div class="comment-item-content">
                    <p class="comment-content-text" :style="{color:item.is_delete?'#9c9c9c':'#404040'}"
                       @touchstart.prevent="onTouchStart(item)" @touchmove.prevent="onTouchMove"
                       @touchend.prevent="onTouchEnd(item)">
                      {{ item.is_delete ? '该评论已删除' : item.content }}
                    </p>
                    <div class="comment-content-bottom">
                      <span class="comment-time">{{ item.publish_at | articleTimeFormatFilter }}</span>
                      <span> · </span>
                      <span class="comment-reply" @click="handleClick(item)" v-show="!item.is_delete">回复</span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <w-more-loading v-show="moreLoadingShow"/>
          <!--          <w-no-more v-show="noMoreShow"/>-->
        </cube-scroll>
        <div class="flex-center article-detail-footer" v-show="!commentShow">
          <button type="text" @click="handleClick( commentData,'root' )"><span class="iconfont iconbianji"
                                                                               style="font-size: 12px;margin-right: 6px"/><span>我来说几句...</span>
          </button>
        </div>
      </div>
    </div>
  </w-popup-show>
</template>

<script>
  import WPopupShow from '../../../components/global/w-popup-show'
  import WMoreLoading from '../../../components/global/w-more-loading'
  import WNoMore from '../../../components/global/w-no-more'
  import {windowEventMixin} from '../../../assets/js/mixin/global'
  import {communityMixin} from "../../../assets/js/mixin/community";
  import official from "./official";
  export default {
    name: 'comment-detail',
    mixins: [windowEventMixin,communityMixin],
    props: {
      commentDetailShow: {
        type: Boolean,
        default: false
      },
      commentData: {
        type: Object,
        default: () => {
          return {}
        }
      },
      author:{
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        commentShow: false,
        options: {
          pullUpLoad: true
        }, // scroll 事件配置
        timer: null
      }
    },
    mounted() {
    },
    computed: {
      moreLoadingShow() {
        let {reply_comments: {comments, reply_comment_count}} = this.commentData
        return comments.length < reply_comment_count
      },
      noMoreShow() {
        let {reply_comments: {comments, reply_comment_count}} = this.commentData
        return comments.length === reply_comment_count
      }
    },
    watch: {},
    components: {
      WPopupShow,
      WMoreLoading,
      WNoMore,
      official
    },
    methods: {
      // 开始长按
      onTouchStart(item) {
        this.timer = setTimeout(() => {
          this.commentActionSheet(item)
        }, 500)
        return false
      },
      onTouchMove() {
        clearTimeout(this.timer)
        this.timer = null
      },
      onTouchEnd(item) {
        clearTimeout(this.timer)
        if (this.timer && !item.is_delete) {
          this.handleClick(item)
        }
        return false
      },
      handleClicks(obj) {
        // console.log(this.commentData)
        // obj.roo_id = this.commentData.id;
        this.handleClick(obj);
      },
      handleClose() {
        this.$emit('handleClose')
      },
      updateLikeStatus(data) {
        this.$emit('updateLikeStatus', data)
      },
      // root存在则为回复一级评论   不存在为回复二级评论
      handleClick(data, root) {
        this.$emit('handleComment', 'reply', data, root)
      },
      onPullingUp() {
        if (!this.noMoreShownoMoreShow) {
          this.$emit('onPullingUp')
        }
      },
      commentActionSheet(data) {
        this.timer = null
        this.$emit('commentActionSheet', data)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";

  .comment-detail-content {
    width: 100vw;
    @include ipx-footer(calc(calc(var(--vh, 1vh) * 85)), 1px);

    .detail-header {
      padding: 16px 24px;

      .iconx {
        font-size: 18px;
        color: #000;
        font-weight: 500;
      }

      .title {
        color: $color-title;
        font-size: $font-size-medium-x;
      }
    }

    .comment-detail {
      height: calc(calc(var(--vh, 1vh) * 95) - 165px);
      // @include ipx-content-bottom(50px);
      .comment-item {
        padding: 24px;
        border-bottom: 1px solid #F9F9F9;

        &:last-child {
          border-bottom: none;
        }
        .avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 8px;
          object-fit: cover;
        }
        .comment-user-info {
          margin-bottom: 8px;
          align-items: flex-start;

          .info {
            display: flex;
            .user-info-box{
              display: flex;
              flex-direction: column;
              justify-content: center;
            }


            span {
              font-size: $font-size-medium;
              color: #404040;
              font-weight: 500;
              @include ellipsis(110px);
            }

            .root-comment-user {
              @include ellipsis(260px)
            }
          }

          .iconfont {
            color: #BCBCBC;
            font-size: 12px;
            margin: 0 10px;
          }

          /*.reply-to-user {*/
          .user-name {
            font-size: $font-size-medium;
            color: $color-dark-gray;
            @include ellipsis(110px);
          }

          /*}*/
          .approve {
            position: relative;
            padding-right: 22px;
            /*background: blue;*/
            line-height: 18px;

            span {
              /*min-width: 14px;*/
              color: #404040;
              font-size: $font-size-small;
            }

            .iconfont {
              position: absolute;
              margin: 0;
              font-size: 18px;
              right: 0;
            }

            .icondianzan1 {
              color: $color-theme;
            }
          }
        }

        .comment-item-content {
          .comment-content-text {
            margin-bottom: 16px;
            color: $color-title;
            line-height: 24px;
            font-size: 16px;
            letter-spacing: 0.4px;
            word-break: break-all;
            white-space: pre-line;
          }

          .comment-content-bottom {
            font-size: $font-size-small;
            color: #9c9c9c;
            margin-bottom: 12px;
          }
        }
      }

      .comment-other-detail {
        background-color: #F9F9F9;
      }
    }

    .no-more {
      margin: 0;
      padding: 16px 0;
      background-color: #f9f9f9;
    }

    .article-detail-footer {
      bottom: 0;
      padding: 0 24px;
      @include ipx-footer(50px, 1px);
      background-color: $color-light;
      border-top: 1px solid #F5F5F7;
      width: 100vw;

      button {
        height: 32px;
        border-radius: 16px;
        background-color: #f9f9f9;
        color: #9C9C9C;
        border: none;
        width: 100%;
        text-align: left;
        padding-left: 24px;
      }
    }
  }

  .identity {
    margin-top: 8px;
    font-size: 13px;
    font-weight: 400;
    color: #9C9C9C;
  }

  .like-enter, .like-leave-to {
    transform: scale(0);
  }

  .like-enter-active {
    transition: all 0.2s .2s;
  }

  .like-leave-active {
    transition: all .2s;
  }

  .not-enter, .not-leave-to {
    transform: scale(0);
  }

  .not-enter-active {
    transition: all .2s .2s;
  }

  .not-leave-active {
    transition: all .2s;
  }
</style>
